import { Skeleton } from '@/components/ui/skeleton';

export default function ItemSkeleton() {
  return (
    <div className="min-h-screen px-3 pb-20">
      <div className="mb-4 mt-1 flex text-sm">
        <Skeleton className="me-4 h-4 w-24" />
        <Skeleton className="me-4 h-4 w-36" />
        <Skeleton className="me-4 h-4 w-28" />
        <Skeleton className="h-4 w-24" />
      </div>

      <div className="mb-4 flex justify-between">
        <Skeleton className="h-7 w-[500px]" />
        <Skeleton className="h-7 w-[100px]" />
      </div>

      <div className="flex flex-col justify-between gap-3 sm:flex-row">
        <div className="sm:w-[75%]">
          <Skeleton className="mb-4 h-[410px]" />
          <div className="mb-4 flex items-center justify-center">
            <Skeleton className="h-[50px] w-[300px]" />
          </div>
          <Skeleton className="mb-4 h-[80px]" />
          <Skeleton className="mb-4 h-[60px]" />
          <Skeleton className="mb-4 h-[40px]" />
        </div>

        <div className="flex flex-col gap-3 sm:w-[25%]">
          <Skeleton className="h-[420px]" />
          <Skeleton className="h-[80px]" />
          <Skeleton className="h-[260px]" />
          <Skeleton className="h-[100px]" />
        </div>
      </div>

      <div className="my-4">
        <Skeleton className="h-[150px]" />
      </div>

      <div className="mt-6">
        <div className="mb-4 flex gap-2">
          <Skeleton className="h-10 w-32" />
          <Skeleton className="h-10 w-32" />
        </div>
        <Skeleton className="h-[300px]" />
      </div>
    </div>
  );
}
